import React from 'react';

function RHMetricCard({ label, value, detail, tone = 'default' }) {
  return (
    <article className={`rh-metric-card rh-metric-card--${tone}`}>
      <span className="rh-metric-card__label">{label}</span>
      <strong className="rh-metric-card__value">{value ?? '-'}</strong>
      {detail && <span className="rh-metric-card__detail">{detail}</span>}
    </article>
  );
}

export default RHMetricCard;
